class deleteRsvp {
    constructor(Alert, $http, $state, $stateParams, $translate) {

        this.key = 'delete-rsvp';
        this.title = 'Delete';
        this.level = 'archived-highlight';
        this.icon = 'fal fa-trash-alt';
        this.alert = Alert;
        this.api = $http;
        this.order = 15;
        this.state = $state;
        this.back = $stateParams.back;
        this.params = $stateParams.backParams || {
            id: $stateParams.id
        };
        this.translate = $translate;
    }

    action(rsvp, vm) {
        const translatedValue = (path, params) => {
            return this.translate.instant(`guestlists.workflows.ask-to-delete-rsvp.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', {rsvp_name: rsvp.contact.data.full_name || rsvp.contact.data.first_name + ' ' + rsvp.contact.data.last_name}),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
                wait: true
            }).then(() => {
            return this.api.delete(`guestlists/${ vm.guestlist.id }/rsvps/${ rsvp.id }`, {data: {force: true}})
                .then(() => {
                    return this.state.go(this.back, this.params);
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.guestlists')
    .factory('deleteRsvp', [
        'Alert',
        '$http',
        '$state',
        '$stateParams',
        '$translate',
        (Alert, $http, $state, $stateParams, $translate) => new deleteRsvp(Alert, $http, $state, $stateParams, $translate)
    ]);




// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/detailed/delete-rsvp.js